export class SearchSpecification {
    fields: string[] = [];
    filters: any[] = [];
    rowCount: number;
    startRow: number;
    sort: string;
    order: string;
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/search-specification.model.ts